import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/internal/operators/tap';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
function getRandomNumber() {
    return Math.floor(Math.random() * 1000000000000000);
}
var PropertiesService = /** @class */ (function () {
    function PropertiesService(http) {
        this.http = http;
        this.properties = {};
    }
    PropertiesService.prototype.fetch = function () {
        var _this = this;
        var params = { cachebust: getRandomNumber().toString() };
        return this.http.get('/properties/properties.json', { params: params }).pipe(tap(function (properties) { return _this.properties = properties; }));
    };
    PropertiesService.prototype.get = function (property) {
        return this.properties[property] || undefined;
    };
    PropertiesService.prototype.isFeatureDisabled = function (featureName) {
        var disabledFeatures = this.get('disabledFeatures');
        if (!disabledFeatures) {
            return false;
        }
        disabledFeatures = disabledFeatures.replace(/\s/g, '');
        var disabledFeaturesArr = disabledFeatures.split(',');
        return disabledFeaturesArr.indexOf(featureName) !== -1 ? true : false;
    };
    PropertiesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropertiesService_Factory() { return new PropertiesService(i0.ɵɵinject(i1.HttpClient)); }, token: PropertiesService, providedIn: "root" });
    return PropertiesService;
}());
export { PropertiesService };
